package org.zq.pixelset.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import org.jetbrains.compose.resources.Font
import org.zq.pixelset.generated.resources.Res
import org.zq.pixelset.generated.resources.pixelset_sans_sc

/** PixelSet 全局字体（来自 composeResources/font） */
val PixelSetFontFamily: FontFamily
    @Composable
    get() = FontFamily(
        Font(Res.font.pixelset_sans_sc, FontWeight.Light, FontStyle.Normal),
        Font(Res.font.pixelset_sans_sc, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.pixelset_sans_sc, FontWeight.Medium, FontStyle.Normal),
        Font(Res.font.pixelset_sans_sc, FontWeight.SemiBold, FontStyle.Normal),
        Font(Res.font.pixelset_sans_sc, FontWeight.Bold, FontStyle.Normal),
    )
